<template>
  <div>
    <app-cells><h1 class="title">POS Transactions</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'FinancePosTransactions',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'finance-pos-transactions-pending', label: 'Transactions'},
        { name: 'finance-pos-transactions-imports', label: 'Imports'},
      ],
    }
  },
}
</script>
